import { useState, useCallback, useMemo } from "react";

import Filters from "../../components/opportunity-inventory/filterComponent.jsx";
import { useOpportunityInventory } from "../../api/opportunities/useOpportunityInventory.js"
import OpportunityTableSearchBar from "../../components/opportunity-inventory/opportunityTableSearchBar.jsx";
import OpportunityTable from "../../components/opportunity-inventory/opportunityTable.jsx";
import OpportunityPagination from "../../components/opportunity-inventory/opportunityTablePagination.jsx";
import { useHunterFarmerList } from "@/api/auth/useHunterFarmerList";
import { LeadInventoryPaginationSkeleton } from "@/components/lead-inventory/skeleton/leadInventorySkeleton.jsx";
import { OpportunityTableSkeleton } from "@/components/opportunity-inventory/Skeleton/OpportunityTableSkeleton.jsx";

export default function AllOpportunityInventoryPage() {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [filters, setFilters] = useState(null);
    const [searchName, setSearchName] = useState("");

    const fromAll = true
    const { data, totalOpportunity, isLoading, absoluteTotal, totalPages } = useOpportunityInventory(page, pageSize, filters, searchName, fromAll);
    const {farmerListAPI} = useHunterFarmerList()

    // Search bar
    const handleSearch = useCallback((name) => {
        setSearchName(name);
        setPage(1);
    }, []);

    const productsOptions = useMemo(() => [
        { id: 1, label: 'Remittance' },
        { id: 2, label: 'Insurance' },
        { id: 3, label: 'Re-KYC' },
        { id: 4, label: 'Referral' },
        { id: 5, label: 'Financing' },
        { id: 6, label: 'Insurance Renewal' }
    ], []);
    const allStatus = useMemo(() => [
        { id: 1, label: 'Raw Lead' },
        { id: 2, label: 'Fresh Lead' },
        { id: 3, label: 'Profile Completed' },
        { id: 4, label: 'Activated' },
        { id: 5, label: 'Rejected' },
        { id: 6, label: 'Onboarded' },
        { id: 7, label: 'Preparing Quotations' },
        { id: 8, label: 'Pending Selection' },
        { id: 9, label: 'Pending Payment' },
        { id: 10, label: 'Expired' },
        { id: 11, label: 'To Be Re-KYC' }
    ], []);
    const remittanceStatus = useMemo(() => [
        { id: 1, label: 'Collecting Documents' },
        { id: 2, label: 'Compliance Reviewing' },
        { id: 3, label: 'Pending Resubmission' },
        { id: 4, label: 'KYC Approved' },
        { id: 5, label: 'To Be Re-KYC' },
        { id: 6, label: 'KYC Rejected' },
    ], []);
    const referralStatus = useMemo(() => [
        { id: 1, label: 'Information Gathered' },
        { id: 2, label: 'Onboarded' }
    ], []);
    const insuranceStatus = useMemo(() => [
        { id: 1, label: 'Preparing Quotation' },
        { id: 2, label: 'Pending Selection' },
        { id: 3, label: 'Pending Payment' },
        { id: 4, label: 'Expired' }
    ], []);

    const handleFilterChange = useCallback((filters) => {
        const selectedFilters = {
            products: filters.products.map(id => 
                productsOptions.find(option => option.id === id)?.label
            ).filter(Boolean),
            all_status: filters.allStatus.map(id =>
                allStatus.find(option => option.id === id)?.label
            ).filter(Boolean),
            farmer: filters.farmer.map(id => 
                farmerListAPI.find(option => option.id === id)?.id
            ).filter(Boolean),
            remittance_status: filters.remittanceStatus.map(id =>
                remittanceStatus.find(option => option.id === id)?.label
            ).filter(Boolean),
            referral_status: filters.referralStatus.map(id =>
                referralStatus.find(option => option.id === id)?.label
            ).filter(Boolean),
            insurance_status: filters.insuranceStatus.map(id =>
                insuranceStatus.find(option => option.id === id)?.label
            ).filter(Boolean)
        };
        
        setPage(1);
        setFilters(selectedFilters);
    }, [productsOptions, allStatus, farmerListAPI, remittanceStatus, referralStatus, insuranceStatus]);
    return (
        <div className="py-2 px-3 md:px-6">
            <div className='py-2 md:py-4'>
                <Filters fromAll={fromAll} onFilterChange={handleFilterChange} />
            </div>
            <div className="max-auto mx-auto bg-white border-t rounded-t-lg shadow-[2px_0_8px_rgba(0,0,0,0.1)]">
                <div className="p-3 md:p-4 flex flex-col gap-3">
                    {/* Search bar - full width on mobile */}
                    <OpportunityTableSearchBar 
                        onSearch={handleSearch}
                        isLoading={isLoading}
                    />
                </div>
            </div>
            {isLoading ? (
                <>
                    <div className="max-auto mx-auto bg-white shadow-md rounded-b-lg ">
                        <LeadInventoryPaginationSkeleton/>
                        <OpportunityTableSkeleton/>
                    </div>
                </>
            ):(
                <>
                    <div className="max-auto mx-auto bg-white shadow-md rounded-b-lg ">
                        {/* <h1 className="text-2xl font-semibold mb-4 text-gray-800">Lead Inventory Table</h1> */}
                        {/* Pagination */}
                        <OpportunityPagination
                            page={page}
                            setPage={setPage}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            totalOpportunity={totalOpportunity}
                            absoluteTotal={absoluteTotal}
                            totalPages={totalPages}
                        />

                        {/* Table */}
                        <OpportunityTable data={data} fromAll = {fromAll}/>
                    </div>
                </>
            )}
        </div>
    );
}